import { Link } from "react-router-dom";
import { ROUTES } from "../../../core/routes/routes";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import LOGO from "../../../img/logodatralabs.png";
import { useDocumentsQuery } from "./hooks/useDocumentsQuery";
import { usePerfilQuery } from "../../hooks/usePerfilQuery";
import HeaderItemFile from "./HeaderItemFile";
import HeaderItem from "./HeaderItem";
import { useDocumentsCommand } from "./hooks/useDocumentsCommand";
import { useDocumentsSafeCarsQuery } from "./hooks/useDocumentsSafeCarsQuery";
import { useDocumentsSafeCarsCommand } from "./hooks/useDocumentsSafeCarsCommand";
import { useState } from "react";
import ModalTypeVehicle from "./ModalTypeVehicle";
import Cookies from "universal-cookie";
import { useDocumentsRoadAccidentsQuery } from "./hooks/useDocumentsRoadAccidnetsQuery";
import { useDocumentsRoadAccidentsCommand } from "./hooks/useDocumentsRoadAccidentsCommand";
import { useDocumentsAdminCommand } from "./hooks/useDocumentsAdminCommand";
import { useDocumentsAdminQuery } from "./hooks/useDocumentsAdminQuery";
import ModalDocumentHistory from "./ModalDocumentHistory";

const dropdownNavLinkStyle = {
  textDecoration: "none",
  color: "#dee2e6",
};

function HeaderMain() {
  const cookie = new Cookies();
  const nombre_user = cookie.get("nombre_user");
  const logo_empresa = cookie.get("logo_empresa");
  // const logo_empresa = "china.jpg";
  const HOST_FTP = (process.env.REACT_APP_HOST_FTP || "").replace(/\/$/, "");
  const LOGO_COMPANIA = `${HOST_FTP}/documentoLogo/${logo_empresa}`;

  const { perfil } = usePerfilQuery();
  const { documents, refresh } = useDocumentsQuery();
  const { documentsSafeCars, refresh: refreshSafeCar } =
    useDocumentsSafeCarsQuery();
  const { deleteDocument, updateDocument } = useDocumentsCommand(refresh);
  const {
    updateDocument: updateDocumentSafeCar,
    deleteDocument: deleteDocumentSafeCar,
  } = useDocumentsSafeCarsCommand(refreshSafeCar);
  const { documentsRoadAccident, refresh: refreshRoadAccident } =
    useDocumentsRoadAccidentsQuery();
  const {
    uploadDocument: uploadDocumentRoadAccident,
    deleteDocument: deleteDocumentRoadAccident,
  } = useDocumentsRoadAccidentsCommand(refreshRoadAccident);

  const [showModalTypeVehicle, setShowModalTypeVehicle] = useState(false);
  const toggleModalTypeVehicle = () => setShowModalTypeVehicle((prev) => !prev);
  const [historyModal, setHistoryModal] = useState({
    isOpen: false,
    documentId: null,
    documentLabel: "",
    historyType: "institucional",
  });
  const openHistoryModal = ({
    documentId,
    documentLabel,
    historyType = "institucional",
  }) =>
    setHistoryModal({
      isOpen: true,
      documentId,
      documentLabel,
      historyType,
    });
  const openSafeCarsHistoryModal = ({ documentId, documentLabel }) =>
    openHistoryModal({
      documentId,
      documentLabel,
      historyType: "safeCars",
    });
  const closeHistoryModal = () =>
    setHistoryModal({
      isOpen: false,
      documentId: null,
      documentLabel: "",
      historyType: "institucional",
    });

  const { documentsAdmin, refresh: refreshDocumentsAdmin } =
    useDocumentsAdminQuery();
  const { editFile: editFileAdmin, deleteFile: deleteFileAdmin } =
    useDocumentsAdminCommand(refreshDocumentsAdmin);

  function cerrarSesion() {
    cookie.remove("perv_v2_cookies_user_kdfoeinapjdkfawep");
    cookie.remove("compania_user");
    window.location.href = "/";
  }

  return (
    <Navbar bg="dark" variant="dark" expand="xl" sticky="top">
      <Container>
        <Navbar.Brand>
          <Link to={ROUTES.DASHBOARD}>
            <img
              src={LOGO}
              alt="logo"
              style={{ maxHeight: "75%", maxWidth: "50%" }}
            />
          </Link>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav-unico" />

        <Navbar.Collapse
          id="navbar-nav-unico"
          // className="d-flex justify-content-between"
        >
          <Nav className="w-100 flex-fill">
            <NavDropdown
              title="Procedimientos documentacion"
              menuVariant="dark"
              flip="true"
            >
              <div className="px-2">
                <NavDropdown title="Planear" menuVariant="dark" drop="end">
                  {documents.map((document, index) =>
                    document.isTypeFile ? (
                      <HeaderItemFile
                        key={index}
                        documentId={document.id_documentos}
                        file={
                          document.originalNameFile
                            ? document.name_archivo
                            : null
                        }
                        isAdmin={perfil}
                        label={document.desc_documento}
                        onDelete={() =>
                          deleteDocument(document.originalNameFile)
                        }
                        onEdit={updateDocument}
                        onShowHistory={openHistoryModal}
                      />
                    ) : (
                      <HeaderItem
                        key={index}
                        label={document.desc_documento}
                        to={document.url}
                      />
                    )
                  )}
                </NavDropdown>
              </div>

              <div className="px-2">
                <NavDropdown
                  title="Hacer"
                  menuVariant="dark"
                  drop="end"
                  flip="true"
                >
                  <HeaderItemFile
                    label="P9. Plan Anual de Trabajo"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.plan_anual_trabajo}
                    documentId="plan_anual_trabajo"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() => deleteDocumentSafeCar("plan_anual_trabajo")}
                  />
                  <HeaderItemFile
                    label="P10. Plan Anual de Capacitación"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.plan_anual_capacitacion}
                    documentId="plan_anual_capacitacion"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() =>
                      deleteDocumentSafeCar("plan_anual_capacitacion")
                    }
                  />

                  <HeaderItemFile
                    label="P11. Responsabilidad y Comportamiento Seguro"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.respo_comp_seguro}
                    documentId="respo_comp_seguro"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() => deleteDocumentSafeCar("respo_comp_seguro")}
                  />
                  <HeaderItemFile
                    label="P12. Plan de Preparación y Respuesta Ante Emergencias Viales"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.plan_prep_respu_emergencia_vial}
                    documentId="plan_prep_respu_emergencia_vial"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() =>
                      deleteDocumentSafeCar("plan_prep_respu_emergencia_vial")
                    }
                  />

                  <HeaderItemFile
                    label="P13. Investigación Interna de Siniestros Viales"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={
                      documentsSafeCars.investigacion_interna_siniestros_viales
                    }
                    documentId="investigacion_interna_siniestros_viales"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({
                        documentName: documentId,
                        file,
                      })
                    }
                    onDelete={() =>
                      deleteDocumentSafeCar(
                        "investigacion_interna_siniestros_viales"
                      )
                    }
                  />

                  <HeaderItemFile
                    label="P14. Vias Seguras"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.vias_seguras}
                    documentId="vias_seguras"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() => deleteDocumentSafeCar("vias_seguras")}
                  />
                  <HeaderItemFile
                    label="P15. Planificación de Desplazamientos"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.planificacion_desplazamiento}
                    documentId="planificacion_desplazamiento"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() =>
                      deleteDocumentSafeCar("planificacion_desplazamiento")
                    }
                  />

                  <HeaderItemFile
                    label="P16. Inspección de Vehículos"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.inspeccion_vehiculos}
                    documentId="inspeccion_vehiculos"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() =>
                      deleteDocumentSafeCar("inspeccion_vehiculos")
                    }
                  />
                  <HeaderItemFile
                    label="P17. Mantenimiento y Control de Vehículos"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.mantenimiento_control_vehiculo}
                    documentId="mantenimiento_control_vehiculo"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() =>
                      deleteDocumentSafeCar("mantenimiento_control_vehiculo")
                    }
                  />

                  <HeaderItemFile
                    label="P18. Gestión de Cambios"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.gestion_cambio}
                    documentId="gestion_cambio"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() => deleteDocumentSafeCar("gestion_cambio")}
                  />
                  <HeaderItemFile
                    label="P19. Archivo y Retención"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.archivo_retencion}
                    documentId="archivo_retencion"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() => deleteDocumentSafeCar("archivo_retencion")}
                  />
                </NavDropdown>
              </div>

              <div className="px-2">
                <NavDropdown title="Verficar" menuVariant="dark" drop="end">
                  <HeaderItemFile
                    label="P20. Indicadores"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.indicadores}
                    documentId="indicadores"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() => deleteDocumentSafeCar("indicadores")}
                  />

                  <HeaderItemFile
                    label=" P21. Registro y Análisis Estadístico de Siniestros Viales"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.regis_anali_siniestros_viales}
                    documentId="regis_anali_siniestros_viales"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() =>
                      deleteDocumentSafeCar("regis_anali_siniestros_viales")
                    }
                  />
                  <HeaderItemFile
                    label="P22. Autitoría"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.auditoria}
                    documentId="auditoria"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() => deleteDocumentSafeCar("auditoria")}
                  />
                </NavDropdown>
              </div>

              <div className="px-2">
                <NavDropdown title="Actuar" menuVariant="dark" drop="end">
                  <HeaderItemFile
                    label="P23. Mejora Contínua"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.mejora_continua}
                    documentId="mejora_continua"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() => deleteDocumentSafeCar("mejora_continua")}
                  />

                  <HeaderItemFile
                    label="P24. Mecanismos de Participación y Comuniación"
                    isAdmin={perfil}
                    onShowHistory={openSafeCarsHistoryModal}
                    file={documentsSafeCars.meca_participacion_comunicacion}
                    documentId="meca_participacion_comunicacion"
                    onEdit={({ documentId, file }) =>
                      updateDocumentSafeCar({ documentName: documentId, file })
                    }
                    onDelete={() =>
                      deleteDocumentSafeCar("meca_participacion_comunicacion")
                    }
                  />
                </NavDropdown>
              </div>
            </NavDropdown>

            <NavDropdown title="Siniestros viales" menuVariant="dark">
              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_ACCIDENTS}
                style={dropdownNavLinkStyle}
              >
                Registro de reportes
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_INVESTIGATION}
                style={dropdownNavLinkStyle}
              >
                Registro de investigaciones
              </NavDropdown.Item>

              <HeaderItem
                label="Divulgación de lecciones aprendidas"
                to={ROUTES.LIST_DISSEMINATION_LESSON}
              />

              <HeaderItem
                label="Costos de siniestros y juridicos"
                to={ROUTES.REGISTER_CLAIMS_AND_LEGAL_COSTS}
              />

              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_LEGAL_PROCESS_DOCUMENTS}
                style={dropdownNavLinkStyle}
              >
                Documentos de procesos jurídicos
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_LEGAL_PROVISION_DOCUMENTS}
                style={dropdownNavLinkStyle}
              >
                Documentos de provisiones legales
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to={ROUTES.INDICATORS}
                style={dropdownNavLinkStyle}
              >
                Indicadores
              </NavDropdown.Item>

              <HeaderItemFile
                documentId="legalRepVerification"
                file={documentsRoadAccident.legalRepVerification}
                label="Certificación de representante legal"
                isAdmin={perfil}
                onEdit={({ documentId, file }) =>
                  uploadDocumentRoadAccident({ documentName: documentId, file })
                }
                onDelete={() =>
                  deleteDocumentRoadAccident({
                    documentName: "legalRepVerification",
                  })
                }
              />
            </NavDropdown>

            <NavDropdown title="Administrativo" menuVariant="dark">
              <NavDropdown.Item
                as={Link}
                to={ROUTES.RISK_MATRIX}
                style={dropdownNavLinkStyle}
              >
                Matriz de riesgos
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.IDENTIFIED_RISKS}
                style={dropdownNavLinkStyle}
              >
                Riesgos identificados
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.WORK_PLAN_AND_TRAINING}
                style={dropdownNavLinkStyle}
              >
                Plan de trabajo y de capacitaciones
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.COMPLIANCE_ANNUAL_PLAN_ACTIVITIES}
                style={dropdownNavLinkStyle}
              >
                Metas y cumplimiento
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.VARIOUS_DOCUMENT_ADMIN}
                style={dropdownNavLinkStyle}
              >
                Documentos varios
              </NavDropdown.Item>

              <HeaderItemFile
                documentId="certificationLegalRepresentative"
                file={documentsAdmin.certificationLegalRepresentative}
                label="Certificación de representante legal"
                isAdmin={perfil}
                onEdit={({ documentId, file }) =>
                  editFileAdmin({ document: documentId, file })
                }
                onDelete={() =>
                  deleteFileAdmin({
                    document: "certificationLegalRepresentative",
                  })
                }
              />

              <HeaderItemFile
                documentId="evidenceControlsImplemented"
                file={documentsAdmin.evidenceControlsImplemented}
                label="Evidencia de controles implementados"
                isAdmin={perfil}
                onEdit={({ documentId, file }) =>
                  editFileAdmin({ document: documentId, file })
                }
                onDelete={() =>
                  deleteFileAdmin({ document: "evidenceControlsImplemented" })
                }
              />

              <HeaderItemFile
                documentId="certificationSubscribed"
                file={documentsAdmin.certificationSubscribed}
                label="Certificación suscrita por el contador y el revisor fiscal"
                isAdmin={perfil}
                onEdit={({ documentId, file }) =>
                  editFileAdmin({ document: documentId, file })
                }
                onDelete={() =>
                  deleteFileAdmin({ document: "certificationSubscribed" })
                }
              />

              <HeaderItemFile
                documentId="speedLimitCertificate"
                file={documentsAdmin.speedLimitCertificate}
                label="Certificado de límite de velocidad"
                isAdmin={perfil}
                onEdit={({ documentId, file }) =>
                  editFileAdmin({ document: documentId, file })
                }
                onDelete={() =>
                  deleteFileAdmin({ document: "speedLimitCertificate" })
                }
              />
            </NavDropdown>

            <NavDropdown title="Funcionamiento" menuVariant="dark">
              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_FUNCTIONALITY_INDICATORS}
                style={dropdownNavLinkStyle}
              >
                Indicadores
              </NavDropdown.Item>
              <div className="px-2">
                <NavDropdown title="Evidencias" menuVariant="dark" drop="end">
                  <NavDropdown.Item
                    as={Link}
                    to={ROUTES.LIST_FUNCTIONALITY_MONTHLY_REPORT_PDF}
                    style={dropdownNavLinkStyle}
                  >
                    Informes mensuales
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to={ROUTES.LIST_FUNCTIONALITY_SPEED_LIMIT_CERTIFICATE}
                    style={dropdownNavLinkStyle}
                  >
                    Certificado de límite de velocidad
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to={ROUTES.LIST_FUNCTIONALITY_STAFF_TIME_CONTROL}
                    style={dropdownNavLinkStyle}
                  >
                    Control de horario del personal
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to={ROUTES.LIST_FUNCTIONALITY_WORK_ROUTES_LIST}
                    style={dropdownNavLinkStyle}
                  >
                    Listado de rutas
                  </NavDropdown.Item>
                </NavDropdown>
              </div>
            </NavDropdown>

            <NavDropdown title="Vehículos" menuVariant="dark">
              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_SPEED_MANAGMENT}
                style={dropdownNavLinkStyle}
              >
                Gestión de velocidad
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.PREOPERATIVE}
                style={dropdownNavLinkStyle}
              >
                Preoperativo
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_MAINTENANCE}
                style={dropdownNavLinkStyle}
              >
                Mantenimiento
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.MONTHLY_REPORT}
                style={dropdownNavLinkStyle}
              >
                Informes mensuales
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.NUMBER_OF_TRIPS}
                style={dropdownNavLinkStyle}
              >
                Número de desplazamientos
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_INFRACTIONS}
                style={dropdownNavLinkStyle}
              >
                Infracciones
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.LIST_CALL_TO_ATTENTION}
                style={dropdownNavLinkStyle}
              >
                Llamados de atención
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to={ROUTES.COUNT_FAULTS}
                style={dropdownNavLinkStyle}
              >
                Contar fallas
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Administración y usuarios" menuVariant="dark">
              <NavDropdown.Item
                as={Link}
                to="/VehiculoSeguroHojaVidaVehiculos"
                style={dropdownNavLinkStyle}
              >
                Ver vehiculos
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/conductores"
                style={dropdownNavLinkStyle}
              >
                Ver conductores
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/administrar-encuestados"
                style={dropdownNavLinkStyle}
              >
                Administrar encuestados
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/GestionUsuario"
                style={dropdownNavLinkStyle}
              >
                Gestion usuarios
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/encuesta/esv"
                style={dropdownNavLinkStyle}
              >
                ESV
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="/vehiculos-seguros/indicador-ESV"
                style={dropdownNavLinkStyle}
              >
                Indicador ESV
              </NavDropdown.Item>
            </NavDropdown>

            <div className="d-inline">
              <NavDropdown
                title={
                  <img
                    src={LOGO_COMPANIA}
                    alt="logo de la compañia"
                    width={100}
                    height={50}
                  />
                }
              >
                <NavDropdown.Item>{nombre_user}</NavDropdown.Item>
                {perfil && (
                  <NavDropdown.Item as={Link} to={ROUTES.LIST_AUDIT_LOGS}>
                    Logs de auditoría
                  </NavDropdown.Item>
                )}
                <NavDropdown.Item onClick={() => cerrarSesion()}>
                  Cerrar Sesión
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>

      <ModalTypeVehicle
        isOpen={showModalTypeVehicle}
        onClose={toggleModalTypeVehicle}
      />
      <ModalDocumentHistory
        isOpen={historyModal.isOpen}
        onClose={closeHistoryModal}
        documentId={historyModal.documentId}
        documentLabel={historyModal.documentLabel}
        historyType={historyModal.historyType}
        isAdmin={perfil}
      />
    </Navbar>
  );
}

export default HeaderMain;
